export default "__VITE_ASSET__CcQO3lWG__"